import { PasswordResetEmailForm } from "@/features/authenticate/components/passwordResetEmailForm";
import { Container, Stack } from "@mantine/core";

export const ForgetPasswordPage = () => {
	return (
		<Container
			size="xl"
			style={{
				height: "100vh",
			}}
		>
			<Stack align="center" justify="center" h="100%">
				<PasswordResetEmailForm />
			</Stack>
		</Container>
	);
};
